import { FC } from "react";
import { Button, ButtonSize, ButtonVariant, Modal } from "shared/components";

export const LeaveWarningModal: FC<{
  title?: string;
  message?: string;
  open: boolean;
  onClose: () => void;
  onLeave: () => void;
}> = ({
  title = "Leave page?",
  message = "Changes you made will not be saved",
  open,
  onClose,
  onLeave
}) => {
  return (
    <Modal
      opened={open}
      onClose={onClose}
      panelClassName="p-6 max-w-[366px] w-full space-y-4"
    >
      <div className="mx-auto space-y-2 text-center w-[200px]">
        <h1 className="text-xl font-bold">{title}</h1>
        <p className="text-content-500 text-base">{message}</p>
      </div>
      <div className="flex gap-2 w-full">
        <Button
          size={ButtonSize.BASE}
          variant={ButtonVariant.BASE}
          className="w-full"
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          size={ButtonSize.BASE}
          variant={ButtonVariant.PRIMARY}
          className="w-full"
          onClick={onLeave}
        >
          Leave
        </Button>
      </div>
    </Modal>
  );
};
